<template>
  <div class="equipment-summary-container">

    <!-- Essential -->
    <template v-if="equipment.essential.length">
      <div class="title-bar">
        <img src="/img/icon-shield@2x.png" alt="shield"/>
        Security Equipment
      </div>
      <div class="equipment-section">
        <div class="equipment-row" v-for="e in equipment.essential" :key="e.id">
          <div>
            <img class="equipment-image" :src="e.image" alt="" />
          </div>
          <div class="flex-grow">
            <div class="text-bold">{{ e.name }}</div>
            <div>Need short descriptions</div>
          </div>
          <div>
            <div>{{ e.quantity }}</div>
            <div class="text-blue text-bold">free</div>
          </div>
        </div>
      </div>
    </template>

    <!-- Cameras -->
    <template v-if="equipment.cameras.length">
      <div class="title-bar">
        <img src="/img/icon-shield@2x.png" alt="shield"/>
        Cameras and video
      </div>
      <div class="equipment-section">
        <div class="equipment-row" v-for="e in equipment.cameras" :key="e.id">
          <div>
            <img class="equipment-image" :src="e.image" alt="" />
          </div>
          <div class="flex-grow">
            <div class="text-bold">{{ e.name }}</div>
            <div>Need short descriptions</div>
          </div>
          <div>
            <div>{{ e.quantity }}</div>
            <div class="text-blue text-bold">{{ e.price }}</div>
          </div>
        </div>
      </div>
    </template>

    <!-- Home Automation -->
    <template v-if="equipment.homeAutomation.length">
      <div class="title-bar">
      <img src="/img/icon-shield@2x.png" alt="shield"/>
      Home Automation
    </div>
    <div class="equipment-section">
      <div class="equipment-row" v-for="e in equipment.homeAutomation" :key="e.id">
        <div>
          <img class="equipment-image" :src="e.image" alt="" />
        </div>
        <div class="flex-grow">
          <div class="text-bold">{{ e.name }}</div>
          <div>Need short descriptions</div>
        </div>
        <div>
          <div>{{ e.quantity }}</div>
          <div class="text-blue text-bold">{{ e.price }}</div>
        </div>
      </div>
    </div>
    </template>

    <!-- Environmental equipment -->
    <template v-if="equipment.environmental.length">
      <div class="title-bar">
      <img src="/img/icon-shield@2x.png" alt="shield"/>
      Environmental equipment
    </div>
    <div class="equipment-section">
      <div class="equipment-row" v-for="e in equipment.environmental" :key="e.id">
        <div>
          <img class="equipment-image" :src="e.image" alt="" />
        </div>
        <div class="flex-grow">
          <div class="text-bold">{{ e.name }}</div>
          <div>Need short descriptions</div>
        </div>
        <div>
          <div>{{ e.quantity }}</div>
          <div class="text-blue text-bold">{{ e.price }}</div>
        </div>
      </div>
    </div>
    </template>


  </div>
</template>

<script>
export default {
  props: {
    equipment: {
      type: Object,
      required: true,
      default: () => ({
        essential: [],
        cameras: [],

      })
    }
  }
}
</script>

<style lang="scss" scoped>
.equipment-summary-container {
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
}
.title-bar {
  background: #F6F6F6;
  color: #9E9E9E;
  padding: .8rem 1rem .8rem 2.4rem;
  display: flex;
  align-items: center;

  img {
    max-width: 20px;
    margin-right: .9rem;
  }
}

.equipment-row {
  display: flex;
  padding: 1.5rem 2rem;
}

.equipment-image {
  max-width: 50px;
  margin-right: 1.875rem;
}
</style>
